import { Section } from '@shared/components/Section';
import { problema } from '@curso/content/porque';

/**
 * Bloco 2. Responde: por que isso existe.
 *
 * Era buraco marcado em âmbar até 19/10, esperando texto do grupo. O roteiro
 * trouxe.
 *
 * A cena entra em fragmentos curtos, e não num parágrafo, porque cada linha
 * precisa ser reconhecível sozinha: a pessoa vai parar em uma delas, não em
 * todas. E a pergunta de abertura não culpa ninguém, o que importa num texto
 * lido por quem vive a cena.
 */
export function OProblema() {
  return (
    <Section id="o-problema" rotulo="Por que existe" titulo={problema.pergunta}>
      <p className="prosa">{problema.contexto}</p>

      <ul className="mt-7 border-t border-linha">
        {problema.cena.map((linha) => (
          <li
            key={linha}
            className="border-b border-linha py-3 text-apoio text-pretty text-tinta-suave"
          >
            {linha}
          </li>
        ))}
      </ul>

      <p className="prosa mt-8 text-tinta">{problema.remate}</p>
    </Section>
  );
}
